import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import socialPrintTemplateStrings from './contextualStrings';

const propTypes = {
  albumFolder: PropTypes.shape({
    type: PropTypes.string.isRequired,
    subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplateSellPhotosNoJoinCode = ({ account, albumFolder }) => {
  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id="socialSellPhotosMainCopy"
          defaultMessage="Get your photo proofs texted to you and purchase prints directly from your mobile device!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p className="marketing-material-social-cta-copy">
        Visit our profile page below to view your photos:
      </p>
      <p className="marketing-material-social-target-copy">
        waldophotos.com/@{account.username}
      </p>
    </Fragment>
  );
};

SocialPrintTemplateSellPhotosNoJoinCode.propTypes = propTypes;

export default SocialPrintTemplateSellPhotosNoJoinCode;
